export default __webpack_public_path__ + "static/media/210-result-3.5dd7a5f6.svg";